import React, {createContext, useState} from "react";
import "./css/App.css";
import Home from "./Home";
import Modal from "./Modal";
import Logout from "./Logout";
import Login from "./Login";

import ACHDetailByTerminal from "./ACHDetailByTerminal";
import PortfolioMonthlySummary from "./PortfolioMonthlySummary";
import DCCMonthlySummary from "./Reporting/DCCMonthlySummary";
import ProfitMonthlySummary from "./Reporting/ProfitMonthlySummary";
import POSPortfolioSummary from "./Reporting/POSPortfolioSummary";
import {BrowserRouter as Router, Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import axios from "axios";
import TerminalDetailPage from "./TerminalManagement/TerminalDetailPage";
import TerminalLayout from "./TerminalManagement/TerminalLayout";
import KeyManagementLayout from "./KeyManagement/KeyManagementLayout";
import TerminalDashboard from "./TerminalDashboard";
import KeyManagementDashboard from "./KeyManagementDashboard";
import AccountManagerLayout from "./AccountManager/AccountManagerLayout";
import AccountManagerDashboard from "./AccountManagerDashboard";
import TransactionLookupLayout from "./TransactionLookup/TransactionLookupLayout";
import TransactionLookupDashboard from "./TransactionLookupDashboard";
import CashMonitoringDashboard from "./CashMonitoringDashboard";
import C260MonthlySummary from "./C260MonthlySummary";
import C260MonthlyRollUpSummary from "./C260MonthlyRollUpSummary";
import TerminalSurchargeSummary from "./TerminalSurchargeSummary";
import DailyAdjustmentSummary from "./DailyAdjustmentSummary";
import MacKeyManagementLayout from "./MacKeyManagement/MacKeyManagementLayout";
import MacKeyManagementDashboard from "./MacKeyManagementDashboard";
import TerminalBalanceSummaryUI from "./Reporting/TerminalBalanceSummary";
export const terminalListContext = createContext();
function App() {
    const history = useHistory();
    const [terminalList, setTerminalList] = useState([]);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
      axios.interceptors.request.use(

        function (config) {
          console.log("Start Ajax Call");
          document.body.classList.add("loading-indicator");

          return config;
        },
        function (error) {
          console.log("Error");
          document.body.classList.remove("loading-indicator");
          return Promise.reject(error);
        }
      );

  axios.interceptors.response.use(
    function (response) {
      console.log("Done with Ajax call");
      document.body.classList.remove("loading-indicator");
      return response;
    },
    function (error) {
      document.body.classList.remove("loading-indicator");
      console.log("Error fetching the data");
      return Promise.reject(error);
    }
  );

  return (
      <terminalListContext.Provider value={{ terminalList, setTerminalList }}>
            <Router>
              <Switch>
                <Route exact path="/">
                  <Login />
                </Route>
                  <Route exact path="/logout">
                      <Login />
                  </Route>
                <Route exact path="/userMgmt">
                  <Home />
                </Route>
                <Route exact path="/report">
                  <Modal />
                </Route>
                <Route exact path="/achDetailByTerminal">
                  <ACHDetailByTerminal />
                </Route>
                  <Route exact path="/TerminalSurchargeSummary">
                      <TerminalSurchargeSummary />
                  </Route>
                  <Route exact path="/C260Reporting">
                      <C260MonthlySummary />
                  </Route>
                  <Route exact path="/C260RollUpReporting">
                      <C260MonthlyRollUpSummary />
                  </Route>
                  <Route exact path="/DailyAdjustmentSummaryReporting">
                      <DailyAdjustmentSummary />
                  </Route>
                  <Route exact path="/TerminalBalanceSummaryReporting">
                      <TerminalBalanceSummaryUI />
                  </Route>
                  <Route exact path="/CashMonitoring">
                      <CashMonitoringDashboard />
                  </Route>
                  <Route exact path="/portfolioMonthly">
                      <PortfolioMonthlySummary />
                  </Route>
                  <Route exact path="/dccMonthly">
                      <DCCMonthlySummary />
                  </Route>
                  <Route exact path="/profitMonthly">
                      <ProfitMonthlySummary />
                  </Route>
                  <Route exact path="/POSPortfolioSummary">
                      <POSPortfolioSummary />
                  </Route>
                <Route exact path="/termManagement/:path?">
                  <TerminalLayout>
                    <Switch>
                      <Route exact
                             path={[
                                 "/termManagement/view-settings",
                                 "/termManagement/table",
                                 "/termManagement/new-terminal",
                                 "/termManagement/edit-terminal",
                                 "/termManagement",
                             ]}
                      >
                        <TerminalDashboard />
                      </Route>
                      <Route exact path="/termManagement/:terminalId">
                        <TerminalDetailPage />
                      </Route>
                    </Switch>
                  </TerminalLayout>
                </Route>

                  <Route exact path="/keyManagement/:path?">
                      <KeyManagementLayout>
                          <Switch>
                              <Route exact
                                     path={[
                                         "/keyManagement/serviceMgmt",
                                         "/keyManagement/masterKeyBind",
                                         "/keyManagement/encryption",
                                         "/keyManagement/macMasterKeyBind",
                                         "/keyManagement/macEncryption",
                                         "/keyManagement",
                                     ]}
                              >
                                  <KeyManagementDashboard/>
                              </Route>
                          </Switch>
                      </KeyManagementLayout>
                  </Route>
                  <Route exact path="/MackeyManagement/:path?">
                      <MacKeyManagementLayout>
                          <Switch>
                              <Route exact
                                     path={[
                                         "/MackeyManagement/serviceMgmt",
                                         "/MackeyManagement/macMasterKeyBind",
                                         "/MackeyManagement/macEncryption",
                                         "/MackeyManagement",
                                     ]}
                              >
                                  <MacKeyManagementDashboard/>
                              </Route>
                          </Switch>
                      </MacKeyManagementLayout>
                  </Route>
                  <Route exact path="/accountManager/:path?">
                      <AccountManagerLayout>
                          <Switch>
                              <Route exact
                                     path={[
                                         "/accountManager/properties",
                                         "/accountManager/holder",
                                         "/accountManager/bank",
                                         "/accountManager/usage",
                                         "/accountManager/schedule",
                                         "/accountManager/override",
                                         "/accountManager/notes",
                                         "/accountManager",
                                     ]}
                              >

                                  <AccountManagerDashboard/>
                              </Route>
                          </Switch>
                      </AccountManagerLayout>
                  </Route>
                  <Route exact path="/transactionLookup/:path?">
                      <TransactionLookupLayout>
                          <Switch>
                              <Route exact
                                     path={[
                                         "/transactionLookup"
                                     ]}
                              >
                                  <TransactionLookupDashboard/>
                              </Route>
                          </Switch>
                      </TransactionLookupLayout>
                  </Route>
                <Route exact path="/getTerminalByUserId">
                  <ACHDetailByTerminal />
                </Route>
                <Route exact path="/">
                  <Redirect to="/home" />
                </Route>
                <Route path="/logout">
                  <Logout />
                </Route>
              </Switch>
            </Router>
      </terminalListContext.Provider>
  );
}

export default App;
